import {Router, RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login.component';
import {LogoutComponent} from './logout/logout.component';
import {NgModule} from '@angular/core';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  { path: 'logout/:sure', component: LogoutComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
